import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Input } from "@/components/ui/input";
import { PasswordField } from "@/components/auth/PasswordField";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { runPendingSaveAfterAuth, getPendingSave } from "@/lib/pendingSave";

export default function Register() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [name, setName] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    if (password.length < 6) {
      toast.error("Пароль должен быть не короче 6 символов");
      return;
    }
    setLoading(true);
    const res = await register(email, password, name);
    setLoading(false);
    if (res.ok) {
      toast.success("Аккаунт создан");
      const pending = getPendingSave();
      await runPendingSaveAfterAuth();
      // Return-path handoff (e.g. from /master-order-testing when opened anonymously).
      let postLogin = null;
      try {
        postLogin = sessionStorage.getItem("post_login_redirect");
        if (postLogin) sessionStorage.removeItem("post_login_redirect");
      } catch {}
      if (postLogin && postLogin.startsWith("/") && !postLogin.startsWith("//")) {
        nav(postLogin, { replace: true });
      } else if (pending) {
        nav(`/library`, { replace: true });
      } else {
        nav("/hall", { replace: true });
      }
    } else {
      toast.error(res.error || "Не удалось зарегистрироваться");
    }
  };

  return (
    <div className="min-h-screen flex flex-col bg-cream">
      <div className="flex-1 flex flex-col justify-center px-7 py-10 max-w-md w-full mx-auto">
        <div className="mb-8">
          <div className="chip bg-sand/60 text-espresso inline-block mb-3">Anokina Studio</div>
          <h1 className="font-serif text-4xl leading-tight text-espresso">Создать аккаунт</h1>
          <p className="text-sm text-muted-foreground mt-2">
            Сохраняйте многослойные проекты и возвращайтесь к ним в любое время.
          </p>
        </div>

        <form onSubmit={onSubmit} className="space-y-4">
          <div>
            <label className="text-xs uppercase tracking-widest text-muted-foreground">Имя</label>
            <Input
              data-testid="register-name-input"
              name="name"
              autoComplete="name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              className="mt-1 h-12 rounded-2xl"
            />
          </div>
          <div>
            <label className="text-xs uppercase tracking-widest text-muted-foreground">Email</label>
            <Input
              data-testid="register-email-input"
              type="email"
              name="email"
              autoComplete="username"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="mt-1 h-12 rounded-2xl"
            />
          </div>
          <div>
            <label className="text-xs uppercase tracking-widest text-muted-foreground">Пароль</label>
            <PasswordField
              data-testid="register-password-input"
              toggleTestId="register-password-toggle"
              name="password"
              autoComplete="new-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              className="h-12 rounded-2xl"
            />
          </div>
          <Button
            data-testid="register-submit-button"
            type="submit"
            disabled={loading}
            className="btn-pill w-full h-12 bg-espresso hover:bg-espressoDark text-white text-base"
          >
            {loading ? "Создаём…" : "Создать аккаунт"}
          </Button>
        </form>

        <p className="text-sm text-center mt-6 text-muted-foreground">
          Уже есть аккаунт?{" "}
          <Link data-testid="link-to-login" to="/login" className="text-espresso font-medium underline underline-offset-4">
            Войти
          </Link>
        </p>
      </div>
    </div>
  );
}
